export default {
  title: "Autenticación",
  login: {
    title: "Iniciar sesión",
    description: "Inicie sesión en su cuenta",
    form: {
      email: "Correo electrónico",
      password: "Contraseña",
      rememberMe: "Recuérdame",
      submit: "Iniciar sesión",
      forgotPassword: "¿Olvidaste tu contraseña?"
    },
    errors: {
      invalidCredentials: "Correo electrónico o contraseña incorrectos",
      userNotFound: "No se encontró ninguna cuenta con este correo electrónico",
      tooManyAttempts: "Demasiados intentos, inténtelo de nuevo más tarde"
    }
  },
  logout: "Cerrar sesión",
  register: {
    title: "Inscribirse",
    description: "Crea tu cuenta",
    form: {
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      terms: "Acepto las condiciones de uso",
      submit: "Registrarse"
    },
    errors: {
      emailExists: "Ya existe una cuenta con este correo electrónico",
      passwordTooWeak: "La contraseña es demasiado débil",
      passwordsDontMatch: "Las contraseñas no coinciden",
      termsNotAccepted: "Debe aceptar las condiciones de uso"
    }
  },
  forgotPassword: {
    title: "Contraseña olvidada",
    description: "Restablecer su contraseña",
    form: {
      email: "Correo electrónico",
      submit: "Enviar enlace de restablecimiento"
    },
    success: "Se ha enviado un correo de restablecimiento",
    errors: {
      userNotFound: "No se encontró ninguna cuenta con este correo electrónico",
      tooManyAttempts: "Demasiados intentos, inténtelo de nuevo más tarde"
    }
  },
  resetPassword: {
    title: "Restablecer la contraseña",
    description: "Elija una nueva contraseña",
    form: {
      password: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      submit: "Restablecer la contraseña"
    },
    success: "Su contraseña ha sido restablecida",
    errors: {
      invalidToken: "El enlace de restablecimiento es inválido o ha expirado",
      passwordTooWeak: "La contraseña es demasiado débil",
      passwordsDontMatch: "Las contraseñas no coinciden"
    }
  },
  email: "Correo electrónico",
  password: "Contraseña",
  confirmPassword: "Confirmar contraseña",
  rememberMe: "Recordarme",
  loginButton: "Iniciar sesión",
  registerButton: "Registrarse",
  loginWithGoogle: "Iniciar sesión con Google",
  loginWithFacebook: "Iniciar sesión con Facebook",
  registerWithGoogle: "Registrarse con Google",
  registerWithFacebook: "Registrarse con Facebook",
  or: "o",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  dontHaveAccount: "¿No tienes una cuenta?",
  loginHere: "Inicia sesión aquí",
  registerHere: "Regístrate aquí",
  sendResetEmail: "Enviar correo de restablecimiento",
  backToLogin: "Volver al inicio de sesión",
  checkEmail: "Revisa tu correo electrónico",
  resetEmailSent: "Correo de restablecimiento enviado",
  invalidCredentials: "Credenciales inválidas",
  emailRequired: "El correo electrónico es obligatorio",
  passwordRequired: "La contraseña es obligatoria",
  emailInvalid: "Dirección de correo electrónico inválida",
  passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
  passwordsMismatch: "Las contraseñas no coinciden",
  loginSuccess: "Inicio de sesión exitoso",
  registrationSuccess: "Registro exitoso",
  logoutSuccess: "Cierre de sesión exitoso",
  error: "Error de autenticación",
  loginError: "Error de inicio de sesión",
  registrationError: "Error de registro",
  resetPasswordError: "Error al restablecer contraseña",
  socialLoginError: "Error de inicio de sesión social",
  weakPassword: "La contraseña es demasiado débil",
  emailAlreadyExists: "El correo electrónico ya existe",
  userNotFound: "Usuario no encontrado",
  wrongPassword: "Contraseña incorrecta",
  tooManyRequests: "Demasiadas solicitudes, intenta nuevamente más tarde",
  networkError: "Error de red",
  emailVerificationRequired: "Se requiere verificación de correo electrónico",
  emailVerificationSent: "Correo de verificación enviado",
  verifyEmail: {
    title: "Verificar correo electrónico",
    description: "Verifique su dirección de correo electrónico",
    success: "Su correo electrónico ha sido verificado",
    resend: "Reenviar correo de verificación",
    errors: {
      invalidToken: "El enlace de verificación es inválido o ha expirado",
      alreadyVerified: "Este correo electrónico ya está verificado"
    }
  },
  resendVerification: "Reenviar verificación",
  emailVerified: "Correo electrónico verificado con éxito",
  verificationError: "Error de verificación",
  continueWithEmail: "Continuar con correo electrónico",
  continueWithPassword: "Continuar con contraseña",
  terms: "Términos de servicio",
  privacy: "Política de privacidad",
  agreeToTerms: "Acepto los Términos de servicio y la Política de privacidad",
  termsRequired: "Debes aceptar los términos y condiciones",
  firstName: "Nombre",
  lastName: "Apellido",
  fullName: "Nombre completo",
  loading: "Cargando...",
  pleaseWait: "Por favor espera...",
  welcome: "Bienvenido",
  welcomeBack: "Bienvenido de vuelta",
  loginWithApple: "Iniciar sesión con Apple",
  signupWithGoogle: "Registrarse con Google",
  signupWithFacebook: "Registrarse con Facebook",
  signupWithApple: "Registrarse con Apple",
  loggingIn: "Iniciando sesión...",
  continueWith: "o continuar con",
  protectedBy: "Protegido por",
  termsNotice: "Al continuar, aceptas nuestros",
  termsOfService: "Términos de servicio",
  and: "y",
  privacyPolicy: "Política de privacidad",
  verifyPhone: "Verifica tu teléfono",
  verifyPhoneMessage: "Ingresa tu número de teléfono para recibir un código de verificación por SMS",
  phoneNumber: "Número de teléfono",
  phoneNumberFormat: "Sin el primer cero para Francia, ej: 612345678",
  skipStep: "Omitir este paso por ahora",
  verifySms: "Verifica el código SMS",
  verifySmsMessage: "Enviamos un código de 6 dígitos al número",
  resendCodeIn: "Reenviar código en",
  resendCode: "Reenviar código",
  verifyEmailMessage: "Enviamos un código de 6 dígitos a",
  verifyingEmail: "Verificando email...",
  tryAgain: "Intentar de nuevo",
  redirecting: "Redirigiendo...",
  noCodeReceived: "¿No recibiste un código?",
  accessLevels: {
    view: "Solo lectura",
    edit: "Edición",
    manage: "Gestión completa"
  },
  accessInfo: {
    connectedAs: "Conectado como"
  },
  accessRestriction: {
    title: "Acceso restringido",
    insufficientLevel: "Nivel de acceso insuficiente",
    login: "Iniciar sesión"
  },
  currentLevel: "Nivel actual",
  requiredLevel: "Nivel requerido",
  errors: {
    default: "Ocurrió un error",
    suspiciousActivity: "Actividad sospechosa detectada. Por favor intenta de nuevo.",
    recaptchaFailed: "La verificación de seguridad falló. Por favor intenta de nuevo.",
    recaptchaUnavailable: "El servicio de seguridad está temporalmente no disponible. Por favor intenta más tarde.",
    recaptchaTimeout: "La verificación de seguridad tomó demasiado tiempo. Por favor verifica tu conexión e intenta de nuevo.",
    accountExistsWithDifferentCredential: "Ya existe una cuenta con credenciales diferentes",
    popupClosed: "La ventana de inicio de sesión fue cerrada",
    disallowedUserAgent: "Agente de usuario no permitido",
    socialLoginFailed: "Falló el inicio de sesión social",
    invalidPhone: "Número de teléfono inválido",
    genericError: "Ocurrió un error",
    invalidCode: "Código inválido, por favor ingresa los 6 dígitos.",
    loginFailed: "Falló el inicio de sesión",
    googleLoginFailed: "Falló el inicio de sesión con Google",
    facebookLoginFailed: "Falló el inicio de sesión con Facebook",
    emailAlreadyInUse: "Este email ya está en uso",
    invalidEmail: "Email inválido",
    emailNotFound: "Email no encontrado. Por favor reintenta el proceso de registro.",
    verificationFailed: "La verificación falló. Por favor intenta de nuevo.",
    invalidLink: "Enlace de verificación inválido.",
    pendingInvitation: "Error al verificar invitaciones pendientes",
    accept: "Error al aceptar invitación",
    decline: "Error al rechazar invitación",
    loadInvitation: "Error al cargar invitación",
    accountExists: "Ya existe una cuenta con este correo electrónico",
    emailInUse: "Este correo ya está en uso",
    networkError: "Error de red",
    operationNotAllowed: "Operación no autorizada",
    popupCancelled: "Operación cancelada",
    tooManyRequests: "Demasiados intentos, inténtelo de nuevo más tarde",
    weakPassword: "La contraseña es demasiado débil",
    wrongPassword: "Contraseña incorrecta",
    userNotFound: "Usuario no encontrado"
  },
  webViewWarning: "Para iniciar sesión con Google, por favor abre esta página en un navegador estándar como Safari, Chrome o Firefox.",
  signIn: "Iniciar sesión",
  createAccount: {
    submit: "Crear cuenta",
    title: "Crear una cuenta",
    description: "Crea una cuenta para gestionar tu boda",
    benefits: "Beneficios de crear una cuenta"
  },
  signInWithGoogle: "Iniciar sesión con Google",
  continueAsGuest: "Continuar como invitado",
  oauth: {
    google: "Continuar con Google",
    facebook: "Continuar con Facebook",
    apple: "Continuar con Apple"
  },
  messages: {
    loggedIn: "Inicio de sesión exitoso",
    loggedOut: "Sesión cerrada exitosamente",
    registered: "Cuenta creada con éxito",
    emailVerified: "Correo electrónico verificado con éxito",
    passwordReset: "Contraseña restablecida con éxito"
  },
  facebook: {
    accountExists: {
      description: "Ya existe una cuenta con este correo electrónico asociado a otro método de inicio de sesión.",
      step1: "Inicia sesión con tu método habitual",
      step2: "Vincula tu cuenta de Facebook en la configuración",
      title: "Cuenta existente"
    },
    general: {
      privacy: "Privacidad",
      privacyText: "Nunca publicaremos nada en tu muro sin tu permiso.",
      tip1: "Asegúrate de que las ventanas emergentes estén permitidas",
      tip2: "Verifica que estás conectado a Facebook",
      tip3: "Permitir el acceso a tu correo electrónico",
      tip4: "Si el error persiste, pruebe con otro navegador",
      tip5: "O usar correo electrónico y contraseña",
      title: "Iniciar sesión con Facebook"
    },
    popupBlocked: {
      description: "El navegador bloqueó la ventana de inicio de sesión de Facebook.",
      note: "Nota",
      noteText: "Si el problema persiste, intente desactivar temporalmente su bloqueador de anuncios.",
      step1: "Busque el icono de bloqueo en la barra de direcciones",
      step2: "Haga clic en él y permita ventanas emergentes para este sitio",
      step3: "Intente iniciar sesión de nuevo",
      title: "Ventana emergente bloqueada"
    },
    unauthorizedDomain: {
      title: "Dominio no autorizado",
      description: "Este dominio no está autorizado para la autenticación de Facebook.",
      note: "Nota",
      noteText: "Póngase en contacto con el administrador."
    },
    understood: "Entendido"
  }
};
